import { render } from "./selectboxMultiple.vue?vue&type=template&id=555f0863&scoped=true"
import script from "./selectboxMultiple.vue?vue&type=script&lang=js"
export * from "./selectboxMultiple.vue?vue&type=script&lang=js"

import "./selectboxMultiple.vue?vue&type=style&index=0&id=555f0863&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555f0863"]])

export default __exports__